import SubAllocationInventoryTargetingStep from './SubAllocationInventoryTargetingStep'
import SingleAllocationTargetingEnabledStep from './SingleAllocationTargetingEnabledStep'
import SingleAllocationTargetingDisabledStep from './SingleAllocationTargetingDisabledStep'

import { isAdInventoryTargetingEnabled } from '../../../formatters/formatInventoryTargeting'

import { IS_SUB_ALLOCATION } from '../../../../../../../Multiplatform/Partnerships/RightForms/RightCreate/RightCreateForm/sectionsLists/OnsiteRightCreateSections/fields'

export const getQuantityAllocationInventoryTargetingSteps = right => {
  const isSubAllocation = right[IS_SUB_ALLOCATION]
  const adInventoryTargetingEnabled = isAdInventoryTargetingEnabled(right)

  switch (isSubAllocation) {
    case true: {
      return {
        component: <SubAllocationInventoryTargetingStep />,
        show: true
      }
    }

    default:
    case false: {
      switch (adInventoryTargetingEnabled) {
        case true: {
          return {
            component: <SingleAllocationTargetingEnabledStep />,
            show: true
          }
        }

        default:
        case false: {
          return {
            component: <SingleAllocationTargetingDisabledStep />,
            show: true
          }
        }
      }
    }
  }
}
